const layoutState = {
  fullscreen: false,
  isPreview: false,
  activePanels: [],
  isNextFlyerBannerCSBOpen: false,
  isNextFlyerBannerCSBVOpen: false,
  isRetailMediaActive: false,
}

export default layoutState
